import { useState, useRef, useEffect } from "react";
import { FiMenu, FiUser } from "react-icons/fi";
import Logo from "../../elements/logo/Logo";
import NavDemo from './NavDemo';
import MobileMenu from './MobileMenu';
import Darkmode from "./Darkmode";
import useStickyHeader from "./useStickyHeader";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const HeaderOne = ({ btnStyle, HeaderSTyle }) => {
    const [ofcanvasShow, setOffcanvasShow] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const onCanvasHandler = () => {
        setOffcanvasShow(prev => !prev);
    };

    const ref = useRef();
    let [check, setCheck] = useState(true);
    const sticky = useStickyHeader(50);
    const headerClasses = `header-default ${(sticky && check) ? 'sticky' : ''}`;
    const { clientHeight } = ref;

    const checkChange = (value) => {
        setCheck(value);
    };

    // Helper: Check if token is expired (older than 10 days)
    const isTokenExpired = () => {
        const createdAt = localStorage.getItem('token_created_at');
        if (!createdAt) return true;

        const tokenDate = new Date(createdAt);
        const now = new Date();

        const diffTime = now.getTime() - tokenDate.getTime();
        const diffDays = diffTime / (1000 * 3600 * 24);

        return diffDays > 10;
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        const expired = isTokenExpired();

        if (token && !expired) {
            setIsAuthenticated(true);
        } else {
            // Token expired or missing: clear storage & update state
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('token_created_at');
            setIsAuthenticated(false);
        }

        // Optional: Listen to 'tokenUpdated' event to update auth state dynamically
        const updateAuth = () => {
            const t = localStorage.getItem('token');
            const e = isTokenExpired();
            setIsAuthenticated(t && !e);
        };

        window.addEventListener('tokenUpdated', updateAuth);

        return () => {
            window.removeEventListener('tokenUpdated', updateAuth);
        };
    }, []);

    return (
        <>
            <header ref={ref} className={`rn-header header-default ${HeaderSTyle} ${headerClasses}`}>
                <div className="container position-relative">
                    <div className="row align-items-center row--0">
                        <div className="col-lg-1 col-md-4 col-1">
                            <Logo 
                                image={`${process.env.PUBLIC_URL}/images/logo/logo.png`}
                                image2={`${process.env.PUBLIC_URL}/images/logo/logo.png`}
                            />
                        </div>
                        <div className="col-lg-11 col-md-6 col-8 position-static">
                            <div className="header-right">
                                <nav className="mainmenu-nav d-none d-lg-block">
                                    <NavDemo />
                                </nav>

                                <div className="header-btn">
                                    {isAuthenticated ? (
                                        <Link to="/dashboard" className={`btn-default ${btnStyle}`} title="Dashboard">
                                            <FiUser size={18} />
                                        </Link>
                                    ) : (
                                        <Link to="/login" className={`btn-default ${btnStyle}`}>LOGIN</Link>
                                    )}
                                </div>

                                <div className="mobile-menu-bar ml--5 d-block d-lg-none">
                                    <div className="hamberger">
                                        <span className="hamberger-button" onClick={onCanvasHandler}><FiMenu /></span>
                                    </div>
                                </div>

                                <Darkmode />
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <MobileMenu show={ofcanvasShow} onClose={onCanvasHandler} />
        </>
    );
};

export default HeaderOne;
